import { db } from '../firebaseConfig';
import { collection, getDocs, updateDoc, doc, query, where, orderBy, limit, getDoc } from 'firebase/firestore';

export const webhookService = {
    // Buscar avaliações pendentes
    getPendingEvaluations: async () => {
        try {
            const q = query(
                collection(db, 'pending_evaluations'),
                where('processed', '==', false),
                orderBy('receivedAt', 'desc'),
                limit(50)
            );
            const snapshot = await getDocs(q);
            return snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
        } catch (error) {
            console.error('Erro ao buscar avaliações:', error);
            return [];
        }
    },

    // Marcar como processada
    markAsProcessed: async (evaluationId) => {
        try {
            await updateDoc(doc(db, 'pending_evaluations', evaluationId), {
                processed: true,
                processedAt: new Date().toISOString()
            });
            return true;
        } catch (error) {
            console.error('Erro ao marcar como processada:', error);
            return false;
        }
    },

    // Buscar dados de uma avaliação específica
    getEvaluationData: async (evaluationId) => {
        try {
            const docRef = doc(db, 'pending_evaluations', evaluationId);
            const snapshot = await getDoc(docRef);
            if (snapshot.exists()) {
                return snapshot.data();
            }
            return null;
        } catch (error) {
            console.error('Erro ao buscar dados da avaliação:', error);
            return null;
        }
    }
};